//** Push 'SaveToFavorites' Method to specific laravel blade **//
import { SaveToFavorites } from "./save-to-favorites";
$(document).ready(function() {
    SaveToFavorites();
});